import {TokenCredentials} from '../login/tokencredentials';
import {Location} from '../location/location';
import {Bin} from '../location/bin';

export class Task {
    credentials: TokenCredentials;

    id : number;
	userid : number;
    
    priority : number;
    state: number;
    activeUserId: number;
    type: string;
    binId: number;
    bin: Bin;
    sourceLocationId: number;
    sourceLocation: Location;
    destinationLocationId: number;
    destinationLocation: Location;
    quantity: number;

    created : Date;
    updated : Date;
    version : number;
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/task/task.ts